module.exports = __webpack_public_path__ + "static/media/khan-academy.aa45cb0c.jpg";